import React from "react"

import MicOn from './icons/MicOn'
import MicOff from './icons/MicOff'
import CamOn from './icons/CamOn'
import CamOff from './icons/CamOff'
import HangUp from './icons/HangUp'
import Minutes from './icons/Minutes'
import VolOff from './icons/VolOff'
import VolMid from './icons/VolMid'
import VolMax from './icons/VolMax'
import Star from './icons/Star'
import StarFilled from './icons/StarFilled'
import USDRound from './icons/USDRound'
import NoRecord from './icons/NoRecord'
import Play from './icons/Play'
import Locked from './icons/Locked'

const Icon = props => {
  switch (props.name) {
    case 'mic-on':
      return <MicOn {...props} />
    case 'mic-off':
      return <MicOff {...props} />
    case 'cam-on':
      return <CamOn {...props} />
    case 'cam-off':
      return <CamOff {...props} />
    case 'hang-up':
      return <HangUp {...props} />
    case 'minutes':
      return <Minutes {...props} />
    case 'usd-round':
      return <USDRound {...props} />
    case 'vol-off':
      return <VolOff {...props} />
    case 'vol-mid':
      return <VolMid {...props} />
    case 'vol-max':
      return <VolMax {...props} />
    case 'star':
      return <Star {...props} />
    case 'star-filled':
      return <StarFilled {...props} />
    case 'no-record':
      return <NoRecord {...props} />
    case 'play':
      return <Play {...props} />
    case 'locked':
      return <Locked {...props} />
    default:
      return
  }
}

export default Icon